import * as React from 'react';
import {Fragment} from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import {RiContactsBook2Line, RiHome4Line, RiUser5Line} from 'react-icons/ri'
// import {MAIN_TXT_COLOR} from "../contants/themes"
import {BsFillBarChartFill, BsPlusCircleFill} from "react-icons/bs"
import {createTheme, Paper} from '@mui/material';
import createStyles from "@mui/styles/createStyles";

const theme = createTheme({
	components: {
		MuiBottomNavigationAction: {
			styleOverrides: {
				label: {
					color: "red"
				},
				iconOnly: false
			}
		}
	}
})

const useStyle = createStyles({
	root: {
		MuiBottomNavigationAction: {
			root: {
				color: "red"
			}
		}
	}

})

export default function BottomTabs() {
	const [value, setValue] = React.useState(0);

	return (

		<Paper className={"bottom-nav"}>
			<BottomNavigation
				className={"bottom-nav"}
				showLabels
				value={value}
				onChange={(event, newValue) => {
					setValue(newValue);
				}}
			>
				<BottomNavigationAction className={"btn btn-navLink"} label="Trang Chu" icon={<RiHome4Line size={20}/>}/>
				<BottomNavigationAction className={"btn btn-navLink"} label="Hop Dong" icon={<RiContactsBook2Line size={20}/>}/>

				<BottomNavigationAction
					style={{marginTop: "-10px"}}
					label="Tao YCBT"
					icon={<BsPlusCircleFill size={40} color={"var(--color-primary)"}/>}
					className={"btn btn-navLink"}
				/>

				<BottomNavigationAction className={"btn btn-navLink"} label="Boi Thuong" icon={<BsFillBarChartFill size={20}/>}/>
				<BottomNavigationAction className={"btn btn-navLink"} label="Tai Khoan" icon={<RiUser5Line size={20}/>}/>
			</BottomNavigation>
		</Paper>

	);
}
